import "antd/dist/reset.css";
import "./src/styles/global.css";

import React from "react";
import AuthProvider from "./src/hooks/provider";
import ChunkErrorBoundary from "./src/components/ChunkErrorBoundary";

export const wrapRootElement = ({ element }) => (
  <ChunkErrorBoundary>
    <AuthProvider element={element} />
  </ChunkErrorBoundary>
);
